import { css } from 'styled-components';

const AccountHeaderRedesignStyle = css`
  .user-info {
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 0;
    padding: 0 ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
  }
  .header-greets,
  .header-user-name {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs24};
    color: ${(props) => props.theme.colors.BLACK};
  }
  .header-user-name {
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  }
  .header-divider {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[3200]};
    }
  }
  .reward-points-status-bar-container {
    padding: 0 ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }
`;
export default AccountHeaderRedesignStyle;
